// FICHIER : frontend/src/constants/brand.js
export const BRAND = {
  name:       'TOS',
  fullName:   'Talent et Organisation Solutions',
  domain:     'TOS.arkcorporate.com',
  tagline:    "Recrutez mieux, avec l'intelligence artificielle",
  description:"Construisez votre marque employeur, publiez vos offres et laissez l'IA conduire vos entretiens. Tout en un.",
  cta:        'Créer ma marque employeur',
  year:       '2026',
};

export const ROUTES = {
  home:      '/',
  candidat:  '/candidats',
  recruteur: '/recruteur',
};

export const API_URL = 'https://ark-recruitment-backend.onrender.com/api';
